
<div class="tw-shipping-mode" >

  <mat-radio-group class="mat-primary tw-flex tw-column " [(ngModel)]="selectedShipping"  (ngModelChange)="getSelectedShipping($event)">
    @for (sh of listShipping; track sh) {
      <mat-radio-button  [value]="sh" style="text-align: justify !important;"  color="primary">
        <strong class="price-shipping-d">{{ sh.description}}
        </strong>
        <strong class="price-shipping-p price-shipping-p-{{sh.code}} "> - {{ (sh.price/100) | currency :'':'symbol-narrow':'':translate.currentLang}}
        </strong><br>
        <!--          <div  *ngIf="sh && sh.note" [innerHTML]="sh.note | transformHtml" style="text-align: justify !important;"></div>-->
      </mat-radio-button>
      @if (selectedShipping && selectedShipping.ppdId=== sh.ppdId ) {
        <mat-card  class="tw-shipping-card" >
          <div class="tw-shipping-disc">
            @if (selectedShipping && selectedShipping.description) {
              <div [innerHTML]="selectedShipping.description | transformHtml"></div>
            }
            @if (selectedShipping && selectedShipping.note) {
              <div  [innerHTML]="selectedShipping.note | transformHtml"></div>
            }
          </div>
            <div class="tw-shipping-mode-price" style="position: absolute;    top: 0;
    right: 16px;
    font-size: 24px;">{{(selectedShipping.price) / 100 | currency :'':'symbol-narrow':'':translate.currentLang}} </div>
        </mat-card>
      }
    }

  </mat-radio-group>
</div>


